import React, { Suspense } from 'react';

const DelayedSmartPageCustomDomainStep =
  React.lazy(() => import(/* webpackChunkName: "smart-page-custom-domain-step.async" */ './smart-page-custom-domain-step')
    .then(({ SmartPageCustomDomainStepWithI18n }) => ({ default: SmartPageCustomDomainStepWithI18n })));

export const DelayedSmartPageCustomDomainStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedSmartPageCustomDomainStep />
  </Suspense>
);
